module.exports = __webpack_public_path__ + "images/tick_grey.svg";